import { Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router';

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog';
import { useAuth } from 'src/context/auth/use-auth';
import { useInactivityTimer } from 'src/hooks/use-inactivity-timer';
import env from 'env';

function ActiveSessionTimeout({ children }: React.PropsWithChildren) {
  const { state, countdown, resetTimer } = useInactivityTimer();
  const { signOut, signOutToSessionExpired } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (state === 'expired') signOutToSessionExpired();
  }, [state, navigate]);

  return (
    <Fragment>
      {children}
      <AlertDialog open={state === 'warning'}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Still there?</AlertDialogTitle>
            <AlertDialogDescription>
              Your session will expire in {countdown} minutes due to inactivity.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={signOut}>Sign out</AlertDialogCancel>
            <AlertDialogAction onClick={resetTimer}>Stay signed in</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Fragment>
  );
}

function SessionTimeoutProvider({ children }: React.PropsWithChildren) {
  if (env.VITE_INACTIVITY_TIMEOUT_ENABLED) return <ActiveSessionTimeout>{children}</ActiveSessionTimeout>;

  return children;
}

export default SessionTimeoutProvider;
